/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

//import {  Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IObrienHomeHeroViewProps } from './obrien-home-hero';

export default (props: IObrienHomeHeroViewProps) => {
    const { obHeroImage, obHeroImageOverlay, obHeroId, obHeroContent, obHeroButtonLink, obHeroButtonText} = props;
    return (
        <>

            <div className="ob-hero" key={obHeroId}>

                <div className="text-container">
                    <div>
                        {obHeroContent && obHeroContent.length > 0 ? (
                            <>
                            <div className="inside-lg" dangerouslySetInnerHTML={{ __html: obHeroContent }}></div>
                            <div className="around-button"><span className="myButton"><a className="button" href={obHeroButtonLink}>{obHeroButtonText}</a></span></div>
                            </>
                        ) : 
                            <>
                            <div className="inside-lg"><a href={obHeroButtonLink}><div className="heroImgOverlay">{obHeroImageOverlay}</div></a></div>
                            <div className="around-button"><span className="myButton"><a className="button blackFriday" href={obHeroButtonLink}>{obHeroButtonText}</a></span></div>
                            </>
                        }
                        
                    </div>
                </div>
                
                <div className="hero-img-fix">
                    {obHeroImage}
                    <div className="overlay"></div>
                </div>
                
            </div>

    
    </>
    );
};
